const DEFAULT_EMAIL_SERVICE_URL = 'https://api.email.tnonetwork.com';

const getEmailServiceBaseUrl = () => {
  const url = process.env.REACT_APP_EMAIL_SERVICE_URL || DEFAULT_EMAIL_SERVICE_URL;
  return (url || '').replace(/\/$/, '');
};

/**
 * Envía un email usando tnoradio-email-service (Brevo).
 * Endpoint: POST {baseUrl}/api/emails/send
 * Opcional: REACT_APP_EMAIL_PUBLIC_SEND_KEY + EMAIL_PUBLIC_SEND_KEY en el servicio (body.publicSendKey).
 * @param {Object} payload { to, subject, text?, html?, cc?, bcc?, from? }
 */
export async function sendEmail(payload) {
  const baseUrl = getEmailServiceBaseUrl();
  const publicSendKey = process.env.REACT_APP_EMAIL_PUBLIC_SEND_KEY || '';
  const normalizeList = (v) => {
    if (!v) return undefined;
    if (Array.isArray(v)) return v.filter(Boolean);
    return [v].filter(Boolean);
  };
  const normalizeFrom = (v) => {
    if (!v) return undefined;
    if (typeof v === 'string') return { address: v };
    return v;
  };
  const body = {
    ...payload,
    to: normalizeList(payload.to),
    cc: normalizeList(payload.cc),
    bcc: normalizeList(payload.bcc),
    from: normalizeFrom(payload.from),
    ...(publicSendKey ? { publicSendKey } : {}),
  };
  const response = await fetch(`${baseUrl}/api/emails/send`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) {
    const message = result.error || result.message || `Error ${response.status}`;
    throw new Error(typeof message === 'string' ? message : 'Error al enviar email.');
  }
  return result;
}

const emailService = { sendEmail, getEmailServiceBaseUrl };

export default emailService;

